<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import Button from "$app/components/ButtonSpinner.svelte"
  import { ChevronRight } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  import app_store from "@images/onboarding/app-store.png"
  import google_play from "@images/onboarding/google-play.png"
  import mobile_app from "@images/onboarding/mobile-app.png"

  let saving = $state(false)
  let completed = $state(true)
  let errors = $state({})

  async function nextStep(): Promise<void> {
    saving = true
    errors = {}

    try {
      const resp = await xhr.patch(
        `/plan_onboarding/${appStore.plan.id}/complete.json`,
        {
          plan: { onboarding_step: "next_step" }
        }
      )

      window.location.href = `/plans/${appStore.plan.id}/goals?page=hierarchy`
    } catch (e) {
      if (e.response.data) {
        errors = e.response.data
      } else {
        if (typeof Honeybadger.notify !== "undefined") {
          Honeybadger.notify(e)
        }
      }
      toast("There was an error saving your plan data", "error")
    } finally {
      saving = false
    }
  }
</script>

<div class="grid grid-cols-1 lg:grid-cols-2">
  <div>
    <h2 class="mt-12 text-5xl font-bold text-left text-white">All Set!</h2>

    <p class="mt-8 text-white text-xl max-w-xl">
      You're all done! Go to your <span class="font-bold">One Page View</span>
      to continue refining your plan and utilize the
      <span class="font-bold">Goals Page</span> to complete building out your
      goal hierarchy. Once your plan is complete then start exploring all the
      other leadership building tools including the
      <span class="font-bold">Activity</span>
      and <span class="font-bold">Recognition</span> features.
    </p>

    <p class="text-gray-200 text-xl max-w-xl mt-8">
      As you get settled don't hesitate to <a
        href="https://calendly.com/anjalwp/lead-with-purpose-discovery-new-sign-up"
        target="_blank"
        class="text-blue-300 hover:underline">contact us</a
      > at any time. We are ready to answer any questions you have and help you learn
      how to best deploy Lead With Purpose in your organization. Also, don't forget
      to check out the Lead With Purpose University for our complete set of courses
      that will get you and your team fully trained in the Fast Attack Leadership
      framework.
    </p>

    <div class="p-8 border border-gray-400 rounded mt-8 bg-gray-500">
      <p class="text-white text-xl max-w-xl">
        To stay connected with your plan on the go, be sure to download the Lead
        With Purpose mobile app from your phone's app store.
      </p>

      <div class="flex justify-center items-center gap-x-5 mt-6">
        <a
          href="https://apps.apple.com/us/app/lead-with-purpose/id1600163569"
          target="_blank"
        >
          <img src={app_store} class="w-auto h-16" alt="iOS App Store" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.leadwithpurpose.lwpMobile"
          target="_blank"
        >
          <img src={google_play} class="w-auto h-16" alt="Google Play" />
        </a>
      </div>
    </div>
  </div>
  <div class="px-6">
    <img
      src={mobile_app}
      class="mx-auto w-96 h-auto"
      alt="Mobile App Screenshot"
    />
  </div>
</div>

<div class="flex justify-center gap-x-5 mt-12">
  <Button
    onclick={nextStep}
    disabled={!completed}
    processing={saving}
    class="btn btn-rounded success btn-big flex items-center gap-1"
  >
    <span class="font-light text-core"> COMPLETE GUIDED SETUP </span>
    <ChevronRight class="size-6 text-core" />
  </Button>
</div>
